import { Dialog, DialogContent, DialogActions, Button } from "@mui/material"
import React, { useState } from "react"
import { createRoot } from "react-dom/client"

/**
 * Affiche un Dialog de confirmation et exécute l'action si OK
 * @param {string} message - message à afficher
 * @param {function} onConfirm - action à exécuter si OK
 */
export function confirmAction(message, onConfirm, onAbord) {
    const container = document.createElement("div")
    document.body.appendChild(container)
    const root = createRoot(container)

    const ConfirmDialog = () => {
        const [open, setOpen] = useState(true)

        const handleClose = () => {
            setOpen(false)
            root.unmount()
            onAbord && onAbord()
            container.remove()
        }

        const handleOk = () => {
            onConfirm && onConfirm()
            setOpen(false)
            root.unmount()
            container.remove()
        }

        return (
            <Dialog open={open} onClose={handleClose}>
                <DialogContent sx={{ whiteSpace: "break-spaces" }}>{message}</DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Quitter</Button>
                    <Button color="primary" onClick={handleOk}>
                        Enregistrer
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    root.render(<ConfirmDialog />)
}
